import { getErrorMessage } from "@akj-dev/affinity-platform";
import { format, parseISO } from "date-fns";

export function formattedDate(
  dateTimeString: string,
  pattern: string = "dd/MM/yyyy"
): string {
  try {
    const date = parseISO(dateTimeString);

    return format(date, pattern);
  } catch (e) {
    console.log(getErrorMessage(e));
  }

  return dateTimeString;
}

export function formattedDateTime(
  dateTimeString: string,
  pattern: string = "HH:mm dd/MM/yyyy"
): string {
  try {
    const date = parseISO(dateTimeString);

    return format(date, pattern);
  } catch (e) {
    console.log(getErrorMessage(e));
  }

  return dateTimeString;
}

export function formattedTime(
  dateTimeString: string,
  pattern: string = "HH:mm"
): string {
  try {
    const date = parseISO(dateTimeString);

    return format(date, pattern);
  } catch (e) {
    console.log(getErrorMessage(e));
  }

  return dateTimeString;
}

export function isValidEmail(email: string) {
  const re =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
